module.exports = __webpack_public_path__ + "static/portfolio00.754ed59a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio00.gif
// module id = 455
// module chunks = 114276838955818